 
export const JobTransferValidationType = Object.freeze({
    PrimaryJobOnly: 0,
    PrimaryJobAndTransferSet: 1,
});
